import React from 'react';
import { signOutOfThisDevice } from '../supabase';
import CipherHeader from './ui/CipherHeader';
import { colors as theme } from '../theme';

const brandColors = {
  gold: theme.gold,
  darkGray: theme.surface1,
  mediumGray: theme.surface2,
  lightGray: theme.surface3,
  silver: theme.textMuted,
  white: theme.text,
};

const ApprovalPending = ({ userName, userEmail }) => {
  const handleLogout = async () => {
    await signOutOfThisDevice();
    window.location.reload();
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <CipherHeader
          title="Account Pending"
          subtitle="Awaiting approval"
        />

        {/* Message */}
        <p style={styles.message}>
          Hi <strong>{userName || 'there'}</strong>! Your account (<strong>{userEmail}</strong>) is awaiting approval from an administrator.
        </p>

        <p style={styles.submessage}>
          You'll receive an email notification once your account is activated and you can start training!
        </p>

        {/* Info box */}
        <div style={styles.infoBox}>
          <div style={styles.infoTitle}>What happens next?</div>
          <ul style={styles.infoList}>
            <li>An admin will review your account within 24-48 hours</li>
            <li>You'll receive an email when your account is approved</li>
            <li>Once approved, you can log in and access your programs</li>
          </ul>
        </div>

        {/* Contact info */}
        <div style={styles.contactBox}>
          <strong>Need immediate access?</strong>
          <br />
          Contact your coach or gym administrator directly.
        </div>

        {/* Logout button */}
        <button onClick={handleLogout} style={styles.logoutBtn}>
          Log Out
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.bg,
    padding: '20px',
  },
  card: {
    maxWidth: '600px',
    width: '100%',
    backgroundColor: theme.surface1,
    borderRadius: '14px',
    padding: '40px',
    textAlign: 'center',
    border: `1px solid ${theme.surface3}`,
  },
  iconContainer: {
    marginBottom: '20px',
  },
  icon: {
    fontSize: '64px',
  },
  title: {
    color: brandColors.gold,
    fontSize: '28px',
    fontWeight: 700,
    marginBottom: '20px',
  },
  message: {
    color: brandColors.white,
    fontSize: '16px',
    lineHeight: '1.6',
    marginBottom: '12px',
  },
  submessage: {
    color: brandColors.silver,
    fontSize: '14px',
    lineHeight: '1.5',
    marginBottom: '30px',
  },
  infoBox: {
    backgroundColor: theme.bg,
    borderRadius: '14px',
    padding: '20px',
    marginBottom: '20px',
    textAlign: 'left',
    border: `1px solid ${theme.surface3}`,
  },
  infoTitle: {
    color: brandColors.gold,
    fontSize: '14px',
    fontWeight: 700,
    marginBottom: '12px',
  },
  infoList: {
    color: brandColors.white,
    fontSize: '14px',
    lineHeight: '1.8',
    paddingLeft: '20px',
    margin: 0,
  },
  contactBox: {
    backgroundColor: 'rgba(212, 175, 55, 0.1)',
    border: `1px solid ${brandColors.gold}`,
    borderRadius: '8px',
    padding: '16px',
    color: brandColors.white,
    fontSize: '14px',
    marginBottom: '30px',
  },
  logoutBtn: {
    backgroundColor: 'transparent',
    border: `2px solid ${brandColors.silver}`,
    borderRadius: '8px',
    color: brandColors.silver,
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: 700,
    cursor: 'pointer',
    transition: 'all 0.2s',
  },
};

export default ApprovalPending;
